import React from 'react';
import { useWatch } from 'react-hook-form';
import { RHTextField } from '../../../../../../../../dum';
import { IOrderQuotation } from '../../../order-quotation-form';
import {
    ORDER_QUOTATION_PRODUCTS,
    PRODUCT,
    PROPOSED_DESCRIPTION,
} from '../order-quotation-products-columns';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../../helpers';

export function ProposedDescriptionInput({ index }: { index: number }) {
    const INPUT_NAME = `${ORDER_QUOTATION_PRODUCTS}.${index}.${PROPOSED_DESCRIPTION}`;
    // Only meaningful on a free line: when a product is chosen the line renders
    // the product's description, so the free-text spec is disabled. Validation
    // (is-proposed-description-required) requires it non-empty when no product.
    const product = useWatch({
        name: `${ORDER_QUOTATION_PRODUCTS}.${index}.${PRODUCT}`,
    }) as IOrderQuotation['order_quotation_products'][number]['product'];

    return (
        <RHTextField
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.proposed_description)}
            disableGutters
            disabled={!!product}
        />
    );
}
